// eslint-disable-next-line
export default [
    {
        id: 1,
        isChecked: false,
        sort: 'Popularity'
    },
    {
        id: 2,
        isChecked: false,
        sort: 'Highest in Price'
    },
    {
        id: 3,
        isChecked: false,
        sort: 'Lowest in Price'
    },
]